var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.affiliate.test)?_c('div',{staticClass:"alert alert-warning"},[_c('font-awesome-icon',{attrs:{"icon":"vial"}}),_vm._v("\n  Nedan så visas testdata för detta exempel. Alla eventuella likheter med riktig data är slumpmässig.\n")],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1291e3c5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Partials/TestData.vue
// module id = 704
// module chunks = 0